//sectors
export const TEL_HOME = '4114-1000'
export const TEL_INDUSTRIES = '4719-9000'
export const TEL_RESIDENTIAL = '4114-1001'
export const TEL_NEIGHBORHOODS = '4114-1001'
export const TEL_APPRAISALS = '4114-1000'
export const TEL_ENTREPRENEURSHIPS = '4114-1000'
export const TEL_LANDS = '4114-1000'

//subsidiaries
export const TEL_SANISIDRO = '4719-9000'
export const TEL_NORDELTA = '4871-5991'
export const TEL_PUERTOS = '4871-8838'
export const TEL_PALERMO = '5300-9696'
export const TEL_PILAR = '5258-8818'
export const TEL_ESCOBAR = '5467-6326'



// WEBPACK FOOTER //
// ./src/constants/phones.js